import { Badge, Box, Button, createStyles, IconButton, makeStyles, withStyles, Avatar } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import "./userbox.css";
import { logout } from "../../../pages/Services/AuthentificationService";
import { getUserData } from "../../../utils/FunctionHelpers";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { FiLogOut } from 'react-icons/fi';
import NotificationsPopover from "../../../components/NotificationsPopover/NotificationsPopover";

import { getCvBlob } from '../../../pages/Services/FileService';

const useStyles = makeStyles((theme) => ({
  large: {
    color: "#FFF",
  },
  notifIcons: {
    padding: "0px 7px 0px 7px !important",
    color: "#FFF",
    cursor: "hand"

  },
}));

const StyledBadge = withStyles((theme) =>
  createStyles({
    badge: {
      top: 13,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: "0 4px",
    },
  })
)(Badge);

const UserBox = ({ history, notifications, setNotifications }) => {
  const classes = useStyles();
  const [isHovered, setIsHovered] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);


  const handleGetImage = async (imageName) => {
    try {
      const imageFile = (await getCvBlob(imageName)).data;
      const reader = new FileReader();
      reader.readAsDataURL(imageFile);
      reader.onloadend = () => {
          setImageUrl(reader.result);
      }
    } catch(err) {
      return "";
    }
  }


  const roles = { ROLE_ADMIN: "ADMIN", ROLE_MANAGER: "MANAGER", ROLE_CONSULTANT: "CONSULTANT" };

  const handleHover = () => {
    setIsHovered(true);
  };

  const getUserInitials = () => {
    const firstInitial = getUserData()?.firstname ? getUserData()?.firstname[0].toUpperCase() : "";
    const lastInitial = getUserData()?.lastname ? getUserData()?.lastname[0].toUpperCase() : "";
    return `${firstInitial}${lastInitial}`.trim();
  };



  useEffect(() => {
    if (getUserData()?.image) {
      handleGetImage(getUserData()?.image);
    }
  }, [])



  return (
    <Box className="header_right iconposistion" sx={{ display: "flex", alignItems: "center", gap: 3 }}>
      <NotificationsPopover notificationsArray={notifications} setNotifications={setNotifications} />
      <div className="profile_info" onMouseEnter={() => handleHover()} onMouseLeave={() => setIsHovered(false)}>
        {localStorage.getItem("token") !== "undefined" ? (
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div className={classes.large}>
              {getUserData() && getUserData()?.titre + "  " + getUserData()?.lastname.toUpperCase() + "   " + getUserData()?.firstname.toUpperCase()}
            </div>
            <IconButton
              size="small"
            >
              <StyledBadge
                overlap="circular"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              >
                <Avatar sx={{ width: 46, height: 46, bgcolor: '#1976d2' }}>
                  {!getUserData()?.image ?
                    getUserInitials() :
                    <img alt="user" width="100%" src={imageUrl} />
                  }
                </Avatar>
              </StyledBadge>
            </IconButton>
          </div>
          
        ) : (
          ""
        )}

        <div
          {...(isHovered ? { style: { zIndex: 405, opacity: 1, display: "block", top: "55px" } } : "")}
          className="profile_info_iner"
        >
          {localStorage.getItem("token") !== "undefined" ? (
            <>
              <p>{roles[getUserData()?.role]}</p>
              <h5><span style={{ textTransform: "capitalize" }}>{getUserData()?.titre + "  "}</span><span>{getUserData()?.lastname + " "}</span> <span>{getUserData()?.firstname}</span> </h5>
              <div className="profile_info_details">
                <Link to="/profile" style={{ color: "#FFF", fontSize: "0.875rem", marginLeft: "0.5rem" }}>
                  MON PROFILE
                </Link>
                <Button onClick={(e) => logout(history)} style={{ color: "#FFF" }}>
                  Se déconnecter
                </Button>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
      <div style={{ fontSize: "19px" }}>
        <li>
          <IconButton className={classes.notifIcons} onClick={(e) => logout(history)} data-toggle="tooltip"
            title="Quitter">
            <StyledBadge overlap="rectangular" color="secondary">
              <FiLogOut />
            </StyledBadge>
          </IconButton>
        </li>
      </div>
    </Box>
  );
};

export default withRouter(UserBox);


const UserBoxMobile = ({ history }) => {
  const classes = useStyles();
  const [isHovered, setIsHovered] = useState(false);
  const roles = { ROLE_ADMIN: "ADMIN", ROLE_MANAGER: "MANAGER", ROLE_CONSULTANT: "CONSULTANT" };

  const handleHover = () => {
    setIsHovered(true);
  };

  return (
    <Box className=" iconposistion" sx={{ display: "flex", marginLeft: "auto", width: "100%", height: "100%" }}>
      <div className="profile_info" onMouseEnter={() => handleHover()} onMouseLeave={() => setIsHovered(false)}>
        {localStorage.getItem("token") !== "undefined" ? (
          <Box className={classes.large} >
            {getUserData() && getUserData()?.titre + "  " + getUserData()?.lastname.toUpperCase() + "   " + getUserData()?.firstname.toUpperCase()}
          </Box>
        ) : (
          ""
        )}

        <div
          {...(isHovered ? { style: { zIndex: 405, opacity: 1, display: "block", top: "30px" } } : "")}
          className="profile_info_iner"
        >
          {localStorage.getItem("token") !== "undefined" ? (
            <>
              <p>{roles[getUserData()?.role]}</p>
              <h5><span style={{ textTransform: "capitalize" }}>{getUserData()?.titre + "  "}</span><span>{getUserData()?.lastname + " "}</span> <span>{getUserData()?.firstname}</span> </h5>
              <div className="profile_info_details">
                <Link to="/profile" style={{ color: "#FFF", fontSize: "0.875rem", marginLeft: "0.5rem" }}>
                  MON PROFILE
                </Link>
                <Button onClick={(e) => logout(history)} style={{ color: "#FFF" }}>
                  Se déconnecter
                </Button>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
      <div style={{ fontSize: "19px" }}>
        <li>
          <IconButton className={classes.notifIcons} onClick={(e) => logout(history)} data-toggle="tooltip"
            title="Quitter">
            <StyledBadge overlap="rectangular" color="secondary">
              <FiLogOut />
            </StyledBadge>
          </IconButton>
        </li>
      </div>
    </Box>
  );
};

export const UserBoxMdMode = withRouter(UserBoxMobile);

